import { createConfirmation } from "react-confirm";
import EditInventoryInfoDialog from "./EditInventoryInfoDialog";

export const showEditInventoryInfoDialog = createConfirmation(EditInventoryInfoDialog);
